export const getValidations = (rules) => ({
  oldPwd: {
    required: true,
    validateOnBlur: false,
  },
  newPwd: {
    required: true,
    validateOnBlur: false,
    minLength: rules ? rules.minLength : null,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && rules && (fieldValue.match(/[A-Z]/g) || []).length < rules.capitalLetters) {
          reject();
        } else if (fieldValue && rules && (fieldValue.match(/[0-9]/g) || []).length < rules.numbers) {
          reject();
        } else if (fieldValue && rules &&
            (fieldValue.match(/[! @ # $ % & ) ( + ]/g) || []).length < rules.specialCharacters) {
          reject();
        } else if (fieldValue && rules && fieldValue.length < rules.minLength) {
          reject();
        } else {
          resolve();
        }
      })),
  },
  confirmNewPwd: {
    required: true,
    validateOnBlur: false,
    matchField: 'newPwd',
  },
});
